import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireMenuOrRedirect } from '@/lib/auth/require-permission';

export const Route = createFileRoute('/_app/ads/material-process')({
  beforeLoad: requireMenuOrRedirect('menu:ads-admin:material-process', '/ads/accounts'),
  component: () => <Outlet />,
});
